import $ from 'jquery';

export default function initContactForm7() {
    if($('.wpcf7').length > 0) {
        $('.wpcf7').each(function() {
            const $form = $(this).find('form');
            $(this).on('wpcf7mailsent', function(e) {
                $form.trigger('submitSuccess');
            });
        })
    }
}